import AboutHero from "@/components/sections/AboutHero";
import AboutPrinciples from "@/components/sections/AboutPrinciples";
import AboutTeam from "@/components/sections/AboutTeam";
import AboutCareer from "@/components/sections/AboutCareer";
import Awards from "@/components/sections/Awards";
import AboutPress from "@/components/sections/AboutPress";
import CTA from "@/components/sections/CTA";
import cmsClient from "@/lib/cmsClient"
import gsap from "gsap";
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Head from "next/head";
import FAQ from "@/components/sections/FAQ";
import WrapperBg from "../components/layout/WrapperBg";
import BGColorChangeWrapper from "../components/layout/BGColorChangeWrapper";
import ScrollToTopChecker from "../components/layout/ScrollToTopChecker";
import Header from "@/components/layout/Header";
import FormPOPUP from "@/components/ui/FormPOPUP";
import Footer from "@/components/layout/Footer";


export async function getStaticProps({ locale }) {
  try {
    const [data, globalData] = await Promise.all([
      cmsClient("page/o-nas", {}, { lang: locale }),
      cmsClient("general", {}, { lang: locale }),
    ]);

    return {
      props: {
        data,
        globalData,
      },
    };
  } catch (error) {
    return {
      props: {
        data: null,
        globalData: null,
      },
    };
  }
}

 gsap.registerPlugin(ScrollTrigger);


export default function About({ data, globalData }) {

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;



  const { acf } = data;


    const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Designic",
        "url": "https://designic.com",
        "email": "info@designic.com",
        "telephone": "+7 921 915 60 83",
        "logo": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg",
        "image": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Малый проспект П.С., д. 5 литер Б, офис 404",
          "addressLocality": "Санкт-Петербург, Россия",
          "postalCode": "197198",
          "addressCountry" : "RU"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "ГЛАВНАЯ",
            "item": "https://designic.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "О НАС",
            "item": "https://designic.com/o-nas"
          }
        ]
      }
    ]
  };

  return (
    <>
      <Head>
        <title>{data.seo.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" key={'viewport-custom'}/>
        <meta charSet="UTF-8"/>
	      <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
        <link rel="profile" href="https://gmpg.org/xfn/11"></link>
        {/* <meta name="robots" content="noindex, nofollow" /> */}
        <meta name="description" content={data.seo.description}/>
        <meta name="robots" content="max-image-preview:large"/>
        <link rel="canonical" href={`${baseUrl}/o-nas/`}/>
        <meta property="og:locale" content="ru_RU"/>
        <meta property="og:site_name" content={data.seo.og.site_name}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={data.seo.og.title}/>
        <meta property="og:description" content={data.seo.og.description}/>
        <meta property="og:url" content="https://designic.com/"/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={data.seo.title}/>
        <meta name="twitter:description" content={data.seo.description}></meta>

        <link rel="alternate" hrefLang="ru" href={`${baseUrl}/o-nas/`}/>
        <link rel="alternate" hrefLang="en" href={`${baseUrl}/en/o-nas/`}/>
        <link rel="alternate" hrefLang="x-default" href={baseUrl}/>

        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-32x32.jpg" sizes="32x32"/>
        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg" sizes="192x192"/>
        <link rel="apple-touch-icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-180x180.jpg"/>
        <meta name="msapplication-TileImage" content="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg"></meta>
        <script
          type="application/ld+json"
          className="aioseo-schema"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <Header headerData={globalData.header}/>
      <FormPOPUP title={data?.cta_title} formInfo={globalData.form} formResponse={globalData?.['form-response']}/>
      <ScrollToTopChecker/>

      <WrapperBg>
        <BGColorChangeWrapper colorClass={'bg-beige'}>
        {acf.hero_status && (
          <AboutHero
            image={acf.hero_image}
            imageSmall={acf.hero_image_mobile}
            title={acf.hero_title}
            text={acf.hero_text}
          />
        )}

        {acf.principles_status && (
          <AboutPrinciples items={acf.principles_slider} />
        )}

        {(globalData?.language !== 'en' && acf.team_status) && (
          <AboutTeam totalItemsCount={acf.team_total} infoTitles={acf.team_block_titles} teamBtnText={acf.team_btn_text} title={acf.team_title} items={acf.team_items} />
        )}

        {(globalData?.language !== 'en' && acf.career_status) && (
          <AboutCareer
            title={acf.career_title}
            text={acf.career_text}
            textAfter={acf.career_text_after}
            textRight={acf.career_text_right}
            textRightSmall={acf.career_text_right_small}
            image={acf.career_image}

            btnText={acf.career_btn_text}
            btnLink={acf.career_btn_link}

            sign1={acf.career_sign}
            sign2={acf.career_sign_2}
          />
        )}

        {acf.awards_status && (
          <Awards title={acf.awards_title} text={acf.awards_desc} items={acf.awards_items} />
        )}

        {acf.press_status ?
          <AboutPress title={acf.press_title} subtitle={acf.press_subtitle} items={acf.press_items} /> : <div className="w-full lg:h-[9vw] xl:h-[10vw]"></div>
        }

        {/* {acf.about_status && (
          <AboutInfo
            title={acf.about_title}
            about_text={acf.about_text}
            link={acf.about_link_url}
            linkText={acf.about_link_text}
          />
        )} */}


        {acf.faq_status && (
          <FAQ title={acf.faq_title} items={acf.faq_itmes} />
        )}
        </BGColorChangeWrapper>
        <BGColorChangeWrapper colorClass={'bg-sky-blue'}>
          {globalData?.language !== 'en' && (
            <CTA title={data.cta_title} image={data.cta_image} formInfo={globalData.form} formResponse={globalData['form-response']} bottomTitle={data.cta_seo?.title} isBottomSectionNeed={true} bottomText1={data?.cta_seo?.text?.[0].text} bottomText2={data.cta_seo?.text?.[1].text}/>
          )}
        </BGColorChangeWrapper>
      </WrapperBg>
      <Footer footerData={globalData.footer} social={globalData.socials} />
    </>
  )
}
